import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { RaadgiverDetailComponent } from './raadgiver-detail/raadgiver-detail.component';
import { RaadgiverResultComponent } from './raadgiver-result/raadgiver-result.component';
import { RaadgiverSearchComponent } from './raadgiver-search/raadgiver-search.component';
import { RaadgivereService } from './raadgivere.service';

@Component({
  selector: 'app-raadgivere',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    RaadgiverSearchComponent,
    RaadgiverResultComponent,
    RaadgiverDetailComponent,
    ButtonModule,
  ],
  templateUrl: './raadgivere.component.html',
  styleUrl: './raadgivere.component.css',
})
export class RaadgivereComponent {
  raadgiverService = inject(RaadgivereService);
  data = this.raadgiverService.datasource.data;

  onClickOpret() {
    this.raadgiverService.opretRaadgiver();
  }

  async onClickExport() {
    await this.raadgiverService.exportData();
  }
}
